import * as React from 'react'
import Stack from '@mui/material/Stack'
import Snackbar from '@mui/material/Snackbar'
import styled from 'styled-components'
import MuiAlert, { AlertProps } from '@mui/material/Alert'
interface AlertMessageProps {
  severity?: any
  message: any
  type?: any
  open?: any
  setOpen?: any
  onClose?: () => void
}
const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})
const Wrapper = styled.div`
  position: relative;
  .alert {
    position: fixed;
    right: 30px;
    bottom: 15px;
    width: 25%;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      width: 59%;
      right: 20px;
    }
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 80%;
      right: 15px;
    }
  }
`
export default function AlertMessage(props: AlertMessageProps) {
  // const [open, setOpen] = React.useState(true)

  return (
    <Wrapper>
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Snackbar
          open={props.open}
          autoHideDuration={3210}
          onClose={props.onClose}
        >
          <Alert
            className="alert"
            onClose={props.onClose}
            severity={props.type || props.severity || 'error'}
            sx={{ width: '100%' }}
          >
            {props.message}
          </Alert>
        </Snackbar>
      </Stack>
    </Wrapper>
  )
}
